import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useDispatch } from 'react-redux';

import HeaderComponent from './AgentComponent/HeaderComponent';
import TabComponent from './AgentComponent/TabComponent';
import ContentPanel from './AgentComponent/ContentPannel';
import RightPanel from './AgentComponent/RightPannel';
import { fetchAssistantDetail } from '../store/app/assistantSlice';

export function EditAssistantModal({
  activeTab,
  setActiveTab,
  assistantDetail,
  assistantId,
  onClose
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(fetchAssistantDetail(assistantId));
      setLoading(false);
    };
    fetchData();
  }, [assistantId, dispatch]);

  const ShimmerBox = ({ width = '100%', height = '1rem', radius = '4px' }) => (
    <div className="shimmer" style={{ width, height, borderRadius: radius }} />
  );

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1055,
        padding: '20px',
      }}
    >
      <motion.div
        className="bg-white w-100 rounded-4 shadow-lg d-flex flex-column"
        style={{
          maxWidth: '1200px',
          height: '90%',
          overflow: 'hidden',
        }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        {/* Modal Header */}
        <div className="d-flex justify-content-between align-items-center border-bottom px-3 py-3">
          <h6 className="mb-0">Edit Assistant</h6>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>

        {/* Tab Section */}
        <div className="px-3 pt-2 pb-2">
          {loading ? (
            <div className="d-flex justify-content-between align-items-center">
              <ShimmerBox width="180px" />
              <ShimmerBox width="80px" />
            </div>
          ) : (
            <>
              <HeaderComponent />
              <div className="mt-2">
                <TabComponent
                  tabs={['Agent', 'LLM', 'Transcriber', 'Voice']}
                  activeTab={activeTab}
                  onTabClick={setActiveTab}
                />
              </div>
            </>
          )}
        </div>

        {/* Modal Body */}
        <div
          className="px-3 py-3 flex-grow-1"
          style={{
            overflowY: 'auto',
            minHeight: 0,
          }}
        >
          {loading ? (
            <div className="d-flex flex-column flex-md-row gap-3">
              <div style={{ flex: 3, minWidth: 0 }}>
                <div className="mb-3"><ShimmerBox height="200px" /></div>
                <div><ShimmerBox height="120px" /></div>
              </div>
              <div style={{ flex: 1.5, minWidth: '280px' }}>
                <ShimmerBox height="100%" />
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column flex-md-row" style={{ gap: '1rem' }}>
              <div style={{ flex: 3, minWidth: 0 }}>
                <ContentPanel
                  activeTab={activeTab}
                  assistantDetail={assistantDetail?.assistant}
                />
              </div>
              <div style={{ flex: 1.5, minWidth: '280px' }}>
                <RightPanel assistantId={assistantId} fromOrg={true}/>
              </div>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
}
